import m from "../../../../geodata/es2015/region/usa/txHigh";
window.am4geodata_region_usa_txHigh = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/region/usa/txHigh.js
// module id = null
// module chunks = 